import { render } from "./tipoley.vue?vue&type=template&id=4e6f9988"
import script from "./tipoley.vue?vue&type=script&lang=js"
export * from "./tipoley.vue?vue&type=script&lang=js"

import "./tipoley.vue?vue&type=style&index=0&id=4e6f9988&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__